const ManagedListsIndex = () =>
  import("@/pages/lab/managedlists/ManagedListsIndex");
const ManagedListsDetail = () =>
  import("@/pages/lab/managedlists/ManagedListsDetail");

export class ManagedListsRoutes {
  constructor() {
    this.route_root = "managed-lists";
    this.type_single = "Managed List";
    this.type_plural = "Managed Lists";

    this.routes = [
      {
        path: this.route_root,
        name: `List ${this.type_plural}`,
        component: ManagedListsIndex,
        meta: { requiresAuth: true }
      },
      {
        path: `${this.route_root}/:id`,
        name: `View ${this.type_single}`,
        component: ManagedListsDetail,
        meta: { requiresAuth: true }
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
